import * as Yup from "yup";

import {
  Button,
  Card,
  CardContent,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { FieldArray, Form, Formik } from "formik";
import {
  createApplicationReferral,
  fetchApplicationReferrals,
} from "../../../../services/applicationReferral";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";

import CustomAlert from "../../../components/CustomAlert";
import CustomDialog from "../../../components/CustomDialog";
import { fetchReferralForFlowStatus } from "../../../../services/flowApplicationStatusService";
import useLocale from "../../../../hooks/useLocale";
import { DropzoneArea, DropzoneDialog } from "material-ui-dropzone";
import GovGrButton from "../../../../components/GovGrButton";

const useStyles = makeStyles({
  dialog: {
    height: 600,
    width: 600,
  },
  uploadButton: {
    marginBottom: 10,
    marginTop: 20,
  },
  dropzone: {
    marginTop: 20,
  },
});

const UploadDialog = ({ open, close, refetch, appl_id, flowId, values }) => {
  const classes = useStyles();
  const [error, setError] = useState("");
  const { t } = useLocale();
  const { data: refsForFlow } = useQuery(
    ["referralsForFlowStatusRequired", flowId, values?.appl_kind_id],
    () => fetchReferralForFlowStatus(flowId, values?.appl_kind_id)
  );
  const [referrals, setReferrals] = useState([]);
  const { data: ApplicationReferral } = useQuery(
    ["applicationReferralsWithId", appl_id],
    () => fetchApplicationReferrals(appl_id)
  );
  // Mutation for creating data
  const { mutate } = useMutation(createApplicationReferral, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });
  useEffect(() => {
    setReferrals(
      refsForFlow?.filter(
        (elem) =>
          !ApplicationReferral?.find(
            ({ referral_kind_id }) => elem.id === referral_kind_id
          )
      )
    );
  }, [refsForFlow, ApplicationReferral]);

  const validationSchema = Yup.object().shape({
    // files: Yup.array().of(
    //   Yup.object().shape({
    //     file: Yup.mixed().
    //       required(t('File is required'))
    //       .test("referral_doc",
    //         t('file is empty'),
    //         value => !value
    //       ).test('content_type',
    //         t('Unsupported Format'),
    //         value => value && SUPPORTED_FORMATS.includes(value.content_type)
    //       ),
    //   })
    // ).required(t('Field is required'))
  });

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleCreateItem = async (values) => {
    // let valuesToSend = [];
    // values.files.forEach((file) => {
    //   valuesToSend.push(file);
    // });

    mutate({ items: JSON.stringify([values.files]) });
  };

  return (
    <CustomDialog
      open={open}
      maxWidth="lg"
      onClose={() => {
        close();
        setError("");
      }}
    >
      <DialogTitle id="form-dialog-title">{t("Upload referral")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            "Pick what kind of referral file you want to Upload, press on Upload button to pick a file from the computer"
          )}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <Formik
        initialValues={{
          files: [],
          filesForView: [],
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleCreateItem(values);
          setSubmitting(false);
        }}
      >
        {({
          submitForm,
          isSubmitting,
          setFieldValue,
          resetForm,
          touched,
          errors,
          values,
          files,
        }) => (
          <Form>
            <DialogContent className={classes.dialog}>
              <FieldArray
                name="files"
                render={(arrayHelpers) => (
                  <div>
                    {referrals?.map((ref, index) => (
                      <Card
                        key={ref.id}
                        variant="outlined"
                        className={classes.docCard}
                      >
                        <CardContent>
                          <Typography variant="h6">
                            {index + 1}. {ref.dscr}
                          </Typography>
                          <DropzoneArea
                            dropzoneText={t(
                              "Drag and drop a file here or click"
                            )}
                            dropzoneClass={classes.dropzone}
                            showPreviewsInDropzone={true}
                            previewText={t("Preview")}
                            filesLimit={1}
                            showPreviews={false}
                            showFileNames={true}
                            onDrop={async (file) => {
                              // values.filesForView.push(file[0]);
                              console.log(index);
                              arrayHelpers.replace(index, {
                                appl_id: appl_id,
                                referral_kind_id: ref.id,
                                referral_doc: await toBase64(file[0]),
                                file_name: file[0].name,
                                content_type: file[0].type,
                              });
                            }}
                            acceptedFiles={[
                              "image/jpeg",
                              "image/png",
                              "application/pdf",
                            ]}
                            maxFileSize={5000000}
                          />
                          {/* <UploadButton index={index} docPerKind={docPerKind} /> */}
                          {/* <input
                            accept="application/pdf,image/jpeg"
                            style={{ display: "none" }}
                            id={`uploadbutton${index}`}
                            multiple
                            hidden
                            type="file"
                            onChange={async (event) => {
                              event.persist();
                              values.filesForView.push(event.target.files[0]);
                              arrayHelpers.replace(index, {
                                appl_id: appl_id,
                                referral_kind_id: ref.id,
                                referral_doc: await toBase64(
                                  event.target.files[0]
                                ),
                                file_name: event.target.files[0].name,
                                content_type: event.target.files[0].type,
                              });
                            }}
                          /> */}
                          {/* <label htmlFor={`uploadbutton${index}`}>
                            <Button
                              className={classes.uploadButton}
                              variant="contained"
                              color="primary"
                              component="span"
                            >
                              {t("Upload referral")}
                            </Button>
                          </label> */}
                        </CardContent>
                        <CardContent>
                          <GovGrButton
                            disabled={!values?.files[index]}
                            className={classes.button}
                            onClick={() => {
                              let url = URL.createObjectURL(
                                values.filesForView[index]
                              );

                              let a = document.createElement("a");
                              a.href = url;
                              a.download = values?.file_name;
                              a.click();
                            }}
                            variant="contained"
                            color="primary"
                            buttonText={t("View")}
                          />

                          <Typography variant="body1">
                            {values?.files?.[index]?.file_name ? (
                              values?.files?.[index]?.file_name
                            ) : (
                              <Typography variant="body1">
                                {t("Select file")}
                              </Typography>
                            )}
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                )}
              />
              {errors["referral_doc"]}
            </DialogContent>
            <DialogActions>
              <GovGrButton
                onClick={() => {
                  close();
                  setError("");
                }}
                buttonText={t("Add")}
              />

              <GovGrButton
                onClick={() => {
                  close();
                  setError("");
                }}
                buttonText={t("Cancel")}
                type="button"
              />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};

export default UploadDialog;
